import React, { useState, useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import { IdentityContext } from "@react-beets/identity";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import Button from "@mui/material/Button";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { useHistory } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import ApartmentIcon from "@mui/icons-material/Apartment";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Menu from "@mui/material/Menu";
import { Link, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "../../images/logo.png";
import LogoDark from "../../images/logo-dark.png";
import { ROUTES } from "../../constants";
import {
  RegisterButton,
  LoginButton,
  LogoutButton,
  IdentityButton,
} from "../buttons";
import "./styles.css";

const iconStyles = {
  width: 125,
};

function TopNav({ variant = "" }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenuId, setActiveMenuId] = useState(null);
  const { isAuthenticated } = useContext(IdentityContext);
  const history = useHistory();
  const location = useLocation();
  const isMenuOpen = Boolean(anchorEl);
  const isPropertyManager =
    localStorage.getItem("userType") === "propertymanager" || false;
  const handleMenu = (event, menuId) => {
    setAnchorEl(event.currentTarget);
    setActiveMenuId(menuId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = (isOpen) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsDrawerOpen(isOpen);
  };

  const isWebsite = variant === "website";

  const rightMenuId = "right-menu";
  const rightMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={rightMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={activeMenuId === rightMenuId && isMenuOpen}
      onClose={handleMenuClose}
    >
      <IdentityButton />
      <LoginButton />
      <RegisterButton />
      <LogoutButton />
    </Menu>
  );

  const getListItem = ({ label, icon, ...props }) => (
    <ListItem {...props}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={label} />
    </ListItem>
  );

  const onClickIAmTenant = () => {
    localStorage.setItem("userType", "tenant");
    history.push(ROUTES.APP_HOME);
  };

  const onClickIAmPropertyManager = (e) => {
    e?.preventDefault();
    localStorage.setItem("userType", "propertymanager");
    history.push(ROUTES.APP_HOME);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar id="top-nav" className={variant}>
        <Toolbar>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              edge="start"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
          </Box>
          <Box sx={{ flexGrow: { xs: 1, md: 0 } }}>
            <Link to={ROUTES.WEBSITE_HOME}>
              <img style={iconStyles} src={!isWebsite ? Logo : LogoDark} />
            </Link>
          </Box>
          <Box
            className="top-nav_menu"
            sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
          >
            {!isWebsite && isAuthenticated && isPropertyManager && (
              <Link
                to={ROUTES.PRIVATE_PROPERTIES}
                className={
                  location.pathname === ROUTES.PRIVATE_PROPERTIES
                    ? "active"
                    : ""
                }
              >
                Properties
              </Link>
            )}
            {!isWebsite && isAuthenticated && !isPropertyManager && (
              <Link
                to={ROUTES.APP_HOME}
                className={location.pathname === ROUTES.INVITES ? "active" : ""}
              >
                Invites
              </Link>
            )}
            {!isWebsite && isAuthenticated && (
              <Link
                to={ROUTES.PRIVATE_LISTINGS}
                className={
                  location.pathname === ROUTES.PRIVATE_LISTINGS ? "active" : ""
                }
              >
                Listings
              </Link>
            )}
          </Box>
          <Box
            sx={{ display: { xs: "none", md: "flex", alignItems: "center" } }}
          >
            {!isWebsite && isAuthenticated && !isPropertyManager && (
              <div>
                <Button
                  component="button"
                  variant="contained"
                  size="small"
                  sx={{ fontWeight: "bold" }}
                  onClick={onClickIAmPropertyManager}
                >
                  I'm a Property Manager
                </Button>
              </div>
            )}
            {!isWebsite && isAuthenticated && isPropertyManager && (
              <div>
                <Button
                  component="button"
                  variant="contained"
                  size="small"
                  sx={{ fontWeight: "bold" }}
                  onClick={onClickIAmTenant}
                >
                  I'm a Tenant
                </Button>
              </div>
            )}
            {!isWebsite && (
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={(event) => handleMenu(event, rightMenuId)}
                color="inherit"
                style={{ color: "#8B3040" }}
              >
                <AccountCircle style={{ color: "#8B3040" }} />
              </IconButton>
            )}
            {rightMenu}
          </Box>

          <Drawer
            anchor="left"
            open={isDrawerOpen}
            onClose={toggleDrawer(false)}
            className="top-nav_drawer"
          >
            <Box
              sx={{ width: 250 }}
              role="presentation"
              onClick={toggleDrawer(false)}
              onKeyDown={toggleDrawer(false)}
            >
                {isAuthenticated && isPropertyManager && <List>
                  <ListItem>
                    <Button
                        component="button"
                        variant="contained"
                        size="small"
                        sx={{ fontWeight: "bold" }}
                        onClick={onClickIAmTenant}
                      >
                        I'm a Tenant
                    </Button>
                  </ListItem>
                  {getListItem({
                      icon: <ApartmentIcon />,
                      component: Link,
                      to: ROUTES.PRIVATE_PROPERTIES,
                      label: "Properties",
                    })}
                  {getListItem({
                      icon: <FormatListBulletedIcon />,
                      component: Link,
                      to: ROUTES.PRIVATE_LISTINGS,
                      label: "Listings",
                    })}
                </List>}
                {isAuthenticated && !isPropertyManager && <List>
                    <ListItem>
                      <Button
                        component="button"
                        variant="contained"
                        size="small"
                        sx={{ fontWeight: "bold" }}
                        onClick={onClickIAmPropertyManager}
                      >
                        I'm a Property Manager
                      </Button>
                    </ListItem>
                  {getListItem({
                      icon: <ApartmentIcon />,
                      component: Link,
                      to: ROUTES.APP_HOME,
                      label: "Invites",
                    })}
                  {getListItem({
                      icon: <FormatListBulletedIcon />,
                      component: Link,
                      to: ROUTES.PRIVATE_LISTINGS,
                      label: "Listings",
                    })}
                </List>}
              <Divider />
              <List>
                <IdentityButton />
                <LoginButton />
                <RegisterButton />
                <LogoutButton />
              </List>
            </Box>
          </Drawer>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default TopNav;
